module.exports = __webpack_public_path__ + "img/Icon_Report_0.b483fb8c.png";